// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".banner{text-align:center;width:100%}.banner .img-banner-desktop{margin:0 auto;width:728px;height:90px;display:block}.banner .img-banner-desktop img{width:100%;height:100%}.banner .img-banner-mobile{display:none}@media only screen and (max-width:900px){.banner .img-banner-desktop{display:none}.banner .img-banner-mobile{margin:0 auto;width:320px;height:100px;display:block}.banner .img-banner-mobile img{width:100%;height:100%}}", ""]);
// Exports
module.exports = exports;
